// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"NewCase_sectionWrapper__TsYNU","sectionTextWrapper":"NewCase_sectionTextWrapper__d5paK","button":"NewCase_button__DZ0oa"};